import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=194a3c42&"
import script from "./announcement.vue?vue&type=script&lang=js&"
export * from "./announcement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports